import {
    Divider,
    IconCallLandlineRegular,
    IconFusionRegular,
    IconMobileDeviceRegular,
    Text1,
    Text2,
    skinVars,
} from '@telefonica/mistica';
import './index.scss';
import { t } from 'i18next';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
export const NewLinesInfoSection = ({ newLineNumbers }: { newLineNumbers: string[] }) => {
    return (
        <div className='newLinesInfo-component'>
            <div className='newLinesInfo-component__title'>
                <IconFusionRegular size={24} color={skinVars.colors.textSecondary} />
                <div className='newLinesInfo-component__title-text'>
                    <Text1 medium color={skinVars.colors.textSecondary}>
                        {t('newLinesNumbersTitle')}
                    </Text1>
                </div>
            </div>
            <div className='newLinesInfo-component__content'>
                {newLineNumbers.map((item, index) => (
                    <div className='newLinesInfo-component__content-section' key={index}>
                        <div className='newLinesInfo-component__content-section-number'>
                            {item.slice(0, 1) !== '9' ? (
                                <IconMobileDeviceRegular size={24} color={skinVars.colors.brandHigh} />
                            ) : (
                                <IconCallLandlineRegular
                                    size={24}
                                    color={skinVars.colors.brandHigh}
                                    style={{ transform: 'rotate(90deg)' }}
                                />
                            )}

                            <div className='newLinesInfo-component__content-section-number-text'>
                                <Text2 regular>{formatMobileNumber(item)}</Text2>
                            </div>
                        </div>

                        <div className='newLinesInfo-component__content-section-divider'>
                            <Divider />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
